module.exports = new __parcel__URL__("mountcancel.5b3e4ac1.png").toString();